import React from "react";
import { Link } from "react-router-dom";
import { Location } from "history";

import { UserIcon } from "../UserIcon";

function createTo({ pathname }: Location) {
  return ({
    pathname: "/settings",
    state: { prevLocation: pathname },
  });
}

export const UserSettings: React.FC = () => (
  <Link to={createTo}>
    <UserIcon />
  </Link>
);
